<template>
    <picture v-if="image != null && image.url != null" :class="pictureClass">
        <source :srcset="imageXxl" media="(min-width: 1920px)" />
        <source :srcset="imageMd" media="(min-width: 992px)" />
        <source :srcset="imageXs" media="(min-width: 853px)" />
        <img :class="imgClass" :src="imageDefault" :loading="getLoadingProperty()" :alt="(image.alternateText + '.')" />
    </picture>
    <div v-if="(image == null || image.url == null) && createFallback">
        <div :class="pictureClass"></div>
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: Object,
            default: () => ({
                url: null,
                hasFocalPoint: null,
                focalPointParameters: null,
                alternateText: null
            })
        },
        moduleName: {
            type: String,
            default: ''
        },
        cssPrefix: {
            type: String,
            default: ''
        },
        createFallback: {
            type: Boolean,
            default: false
        },
        imageParams: {
            type: Object,
            default: () => {}
        },
        disableLazyLoading: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        return {};
    },
    data() {
        return {
            imageXxl: this.image != null ? `/admin/public/getimage.ashx?image=${encodeURIComponent(this.image.url)}&compression=100${this.imageParams.xxlParams}&crop=${this.image.hasFocalPoint ? '7' : '0'}&${this.image.focalPointParameters}` : null,
            imageMd: this.image != null ? `/admin/public/getimage.ashx?image=${encodeURIComponent(this.image.url)}&compression=100${this.imageParams.mdParams}&crop=${this.image.hasFocalPoint ? '7' : '0'}&${this.image.focalPointParameters}` : null,
            imageXs: this.image != null ? `/admin/public/getimage.ashx?image=${encodeURIComponent(this.image.url)}&compression=100${this.imageParams.xsParams}&crop=${this.image.hasFocalPoint ? '7' : '0'}&${this.image.focalPointParameters}` : null,
            imageDefault: this.image != null ? `/admin/public/getimage.ashx?image=${encodeURIComponent(this.image.url)}&compression=100${this.imageParams.defaultParams}&crop=${this.image.hasFocalPoint ? '7' : '0'}&${this.image.focalPointParameters}` : null,
            pictureClass: `${this.moduleName}__${this.cssPrefix}image-wrap`,
            imgClass: `${this.moduleName}__${this.cssPrefix}image`
        };
    },
    methods: {
        getLoadingProperty() {
            return this.disableLazyLoading ? 'eager' : 'lazy';
        }
    }
};
</script>
